
export class AreaSelectionType {
// eslint-disable-next-line sonarjs/public-static-readonly
    static marknadsomrade = "MO";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static resultatomrade = "RO";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static produktionsomrade = "PO";
}

export interface IJlpResultSettings {
    passeradeAntalArbetsdagarInnevarandeManad: number;
    totaltAntalArbetsdagarInnevarandeManad: number;
    periodFrom: any;
    periodTom: any;
}

export interface INamedSokfilter {
    namn: string;
}

export interface ISparadeSokfilter {
    minaFilter: INamedSokfilter[];
}
